import { render, staticRenderFns } from "./main.vue?vue&type=template&id=1d48907e&scoped=true"
import script from "./main.vue?vue&type=script&lang=js"
export * from "./main.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d48907e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/Paldia/Paldia FE/FE-Paldia-Staging/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d48907e')) {
      api.createRecord('1d48907e', component.options)
    } else {
      api.reload('1d48907e', component.options)
    }
    module.hot.accept("./main.vue?vue&type=template&id=1d48907e&scoped=true", function () {
      api.rerender('1d48907e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/phase2/landing-page/components/setting-receipt_photography/main.vue"
export default component.exports